import React, { useState } from "react";
import { ImagePlus, X } from "lucide-react";
import { resolveUrl } from "@/lib/apiClient";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import MediaLibrary from "@/components/admin/MediaLibrary";

export default function ImageField({ value, onChange, label = "Image", testid = "img" }) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      {label && <p className="text-sm font-medium text-[#2C3531] mb-1.5">{label}</p>}
      <div className="flex items-center gap-3">
        <div className="w-20 h-20 rounded-xl overflow-hidden border border-[#E8E6E1] bg-[#F7F5F1] flex items-center justify-center shrink-0">
          {value ? <img src={resolveUrl(value)} alt="" className="w-full h-full object-cover" /> : <ImagePlus className="w-5 h-5 text-[#B0AEA8]" />}
        </div>
        <div className="flex-1 space-y-2">
          <button type="button" onClick={() => setOpen(true)} data-testid={`${testid}-choose`}
            className="text-sm font-semibold text-[#2C3531] px-4 py-2 rounded-full border border-[#E8E6E1] hover:bg-[#F0EFEB] transition-colors">
            Choose from library
          </button>
          <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="or paste an image URL" data-testid={`${testid}-url`} className="h-9 text-xs" />
        </div>
        {value && <button type="button" onClick={() => onChange("")} className="text-[#993333]"><X className="w-4 h-4" /></button>}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader><DialogTitle className="font-serif">Media Library</DialogTitle>
            <DialogDescription>Upload a new image or choose one from your library.</DialogDescription>
          </DialogHeader>
          <MediaLibrary selectable selectedUrl={value} onSelect={(url) => { onChange(url); setOpen(false); }} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
